import './instrument.ts';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fa.ts';
import App from './App.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
